/**
 * Syncs the `_is_trade_account` cart attribute with the logged-in customer's
 * `crm.is_trade_account` metafield (exposed via cart-trade-account-root snippet).
 *
 * The Salesforce ShopifyShippingQuote callback reads this as a line item
 * property to grant free shipping on sample-only orders for trade customers.
 * Cart attributes flow through automatically as line item properties.
 */
(function () {
    'use strict';

    function root() {
        return document.querySelector('[data-cart-trade-account-root]');
    }

    function isTradeAccount() {
        var el = root();
        return !!el && el.getAttribute('data-is-trade-account') === 'true';
    }

    function cartRoute() {
        return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root
            : '/';
    }

    function cartFetch(url, body) {
        return fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
        }).then(function (res) {
            if (!res.ok) {
                return res.text().then(function (t) {
                    throw new Error('Cart request failed: ' + res.status + ' ' + t);
                });
            }
            return res.json();
        });
    }

    /**
     * Cart attributes cannot be deleted, only reset to empty string. Shopify
     * treats an empty-string attribute as absent for carrier service callbacks.
     */
    function desiredValue() {
        return isTradeAccount() ? 'true' : '';
    }

    function syncFromCart(cart) {
        var attrs = (cart && cart.attributes) || {};
        var current = String(attrs._is_trade_account || '');
        var desired = desiredValue();

        if (current === desired) return Promise.resolve(cart);

        return cartFetch(cartRoute() + 'cart/update.js', {
            attributes: { _is_trade_account: desired },
        }).catch(function (err) {
            console.error('[cart-trade-account-manager] sync:', err);
        });
    }

    function fetchAndSync() {
        return fetch(cartRoute() + 'cart.js')
            .then(function (r) {
                return r.json();
            })
            .then(syncFromCart)
            .catch(function (err) {
                console.error('[cart-trade-account-manager] fetch:', err);
            });
    }

    function init() {
        fetchAndSync();

        document.addEventListener(
            'cart:change',
            function (event) {
                var cart = event.detail && event.detail.cart;
                if (cart) {
                    syncFromCart(cart);
                } else {
                    fetchAndSync();
                }
            },
            false,
        );

        document.addEventListener('cart:refresh', fetchAndSync, false);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
